import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

interface ServicesProps {
  lang: 'uk' | 'ru';
}

const content = {
  uk: {
    heading: 'Мої послуги',
    services: [
      {
        icon: 'ri-user-heart-line',
        title: 'Індивідуальні консультації',
        description: 'Особисті зустрічі в комфортній обстановці. Робота з тривогою, депресією, самооцінкою та особистісними кризами.',
        price: 'від 100 €',
      },
      {
        icon: 'ri-vidicon-line',
        title: 'Онлайн-консультації',
        description: 'Зручний формат для тих, хто цінує час. Повноцінна психологічна допомога через відеозв\'язок з будь-якої точки світу.',
        price: 'від 100 €',
      },
    ],
  },
  ru: {
    heading: 'Мои услуги',
    services: [
      {
        icon: 'ri-user-heart-line',
        title: 'Индивидуальные консультации',
        description: 'Личные встречи в комфортной обстановке. Работа с тревогой, депрессией, самооценкой и личностными кризисами.',
        price: 'от 100 €',
      },
      {
        icon: 'ri-vidicon-line',
        title: 'Онлайн-консультации',
        description: 'Удобный формат для тех, кто ценит время. Полноценная психологическая помощь через видеосвязь из любой точки мира.',
        price: 'от 100 €',
      },
    ],
  },
};

export default function Services({ lang }: ServicesProps) {
  const t = content[lang];
  const { ref: headingRef, isVisible: headingVisible } = useScrollAnimation();
  const { ref: card0Ref, isVisible: card0Visible } = useScrollAnimation({ rootMargin: '0px 0px -40px 0px' });
  const { ref: card1Ref, isVisible: card1Visible } = useScrollAnimation({ rootMargin: '0px 0px -40px 0px' });
  const cardRefs = [card0Ref, card1Ref];
  const cardVisible = [card0Visible, card1Visible];

  return (
    <section id="services" className="py-16 md:py-24 bg-white dark:bg-[#121212]">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div
          ref={headingRef}
          className={`text-center mb-10 md:mb-16 transition-all duration-700 ${headingVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
        >
          <h2 className="text-3xl md:text-5xl font-light text-[#333333] dark:text-[#EEEEEE] mb-4">{t.heading}</h2>
          <div className="w-16 h-0.5 bg-[#A8DADC] mx-auto"></div>
        </div>

        <div className="grid sm:grid-cols-2 gap-6 md:gap-8 max-w-3xl mx-auto">
          {t.services.map((service, index) => (
            <div
              key={index}
              ref={cardRefs[index]}
              className={`bg-white dark:bg-[#1E1E1E] rounded-[20px] p-8 md:p-12 shadow-[0_2px_16px_rgba(0,0,0,0.04)] dark:shadow-[0_2px_16px_rgba(0,0,0,0.3)] hover:shadow-[0_8px_32px_rgba(126,200,227,0.12)] dark:hover:shadow-[0_8px_32px_rgba(126,200,227,0.08)] transition-all duration-500 group cursor-pointer ${cardVisible[index] ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
              style={{ transitionDelay: `${index * 150}ms` }}
            >
              <div className="w-16 h-16 md:w-20 md:h-20 bg-[#F1F1F1] dark:bg-[#2A2A2A] rounded-full flex items-center justify-center mb-5 md:mb-6 group-hover:bg-[#7EC8E3] transition-colors duration-300">
                <i className={`${service.icon} text-3xl md:text-4xl text-[#7EC8E3] group-hover:text-white transition-colors duration-300`}></i>
              </div>
              <h3 className="text-xl md:text-2xl font-semibold text-[#333333] dark:text-[#EEEEEE] mb-3 md:mb-4">{service.title}</h3>
              <p className="text-[15px] md:text-[16px] text-[#666666] dark:text-[#AAAAAA] leading-relaxed mb-4 md:mb-5">{service.description}</p>
              <div className="text-[14px] text-[#7EC8E3] font-medium">{service.price}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
